import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loading from "../Components/Loading/Loading";
import EmailVerificationLink from "../Components/EmailVerification/EmailVerificationLink";
import PageNotFound from "../Components/PageNotFound/PageNotFound";

const Home = React.lazy(() => import("../Components/Home/Home"));
const RegisterPage = React.lazy(() =>
  import("../Components/Auth/RegisterPage")
);
const ResumeCreate = React.lazy(() =>
  import("../Components/Candidate/ResumeCreate/ResumeCreate")
);
const GetInTouch = React.lazy(() =>
  import("../Components/Public/GetInTouch/GetInTouch")
);
const ForgotPassword = React.lazy(() =>
  import("../Components/Auth/ForgotPassword")
);

const LoginPage = React.lazy(() => import("../Components/Auth/LoginPage"));

// const Project_search = React.lazy(() =>
//   import("../Components/Public/Project_search/Project_search")
// );
// const Notification = React.lazy(() =>
//   import("../Components/Private/Notification/Notification")
// );
const NewProject = React.lazy(() =>
  import("../Components/Employer/Project/NewProject")
);
const ConnectHistory = React.lazy(() =>
  import("../Components/Candidate/ConnectHistoryAndBidHistory/ConnectHistory")
);
// const ResumeSearch = React.lazy(() =>
//   import("../Components/Public/ResumeSearch/ResumeSearch")
// );
const ResetPassword = React.lazy(() =>
  import("../Components/Auth/ResetPassword")
);
const Profile = React.lazy(() => import("../Components/User/Profile/Profile"));
const ResumePublicView = React.lazy(() =>
  import("../Components/Candidate/ResumePublicView")
);
const ProjectPublicDetail = React.lazy(() =>
  import("../Components/Employer/ProjectPublicDetail")
);

const UnAuthRoute = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Home {...props} />} />
        <Route path="/register" element={<RegisterPage {...props} />} />
        <Route path="/get-in-touch" element={<GetInTouch {...props} />} />
        <Route path="/login" element={<LoginPage {...props} />} />
        <Route
          path="/forgot-password"
          element={<ForgotPassword {...props} />}
        />
        <Route path="/reset/:id" element={<ResetPassword {...props} />} />
        {/*========== user and public url======== */}
        <Route path="/create-resume" element={<ResumeCreate {...props} />} />
        <Route path="/post-project" element={<NewProject {...props} />} />
        <Route path="/user/profile/:id/*" element={<Profile {...props} />} />
        {/* <Route
          path="/resume-search/:userName"
          element={<ResumeSearch {...props} />}
        /> */}
        <Route
          path="/public-view/:userId/:resumeId/*"
          element={<ResumePublicView {...props} />}
        />
        <Route
          path="/verification/:id"
          exact
          element={<EmailVerificationLink {...props} />}
        />{" "}
        <Route
          path="/project-view/:userId/:projectId/*"
          element={<ProjectPublicDetail {...props} />}
        />
        <Route path="/candidate/*" element={<Navigate to="/" />} />
        <Route path="/employer/*" element={<Navigate to="/" />} />
        <Route path="*" element={<PageNotFound {...props} />} />
      </Routes>
    </Suspense>
  );
};

export default UnAuthRoute;
